// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const ClockSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })`
    width: 0.95em;
`;

const Clock = ({ color = navy, ...props }) => (
    <ClockSVG data-test="icon-clock" {...props}>
        <g>
            <g>
                <polygon
                    fill={color}
                    points="26.1,22.9 17.4,22.9 17.4,9.7 20.8,9.7 20.8,19.5 26.1,19.5"
                />
            </g>
            <g>
                <path
                    d="M19,40C8.7,40,0.3,31.6,0.3,21.3S8.7,2.7,19,2.7s18.7,8.4,18.7,18.7S29.3,40,19,40z M19,6.7c-8.1,0-14.6,6.6-14.6,14.6S10.9,36,19,36s14.6-6.6,14.6-14.6S27.1,6.7,19,6.7z"
                    fill={color}
                />
            </g>
            <g>
                <rect fill={color} height="4" width="5.2" x="16.4" />
            </g>
        </g>
    </ClockSVG>
);

export { Clock as default, Clock };
